import { SupportStatus } from '@/types/home';

export const AWAITING_RESPONSE = [
  SupportStatus.REJECT_PROVIDE,
  SupportStatus.NO_RESP,
  SupportStatus.PARTIAL_SUPPORT,
];

export const RESPONDED = [
  SupportStatus.ALL_LOST,
  SupportStatus.FREEZED,
  SupportStatus.PROVIDED_NEXT_ADDRESS,
  SupportStatus.FULL_PROVIDED,
];
